module.exports = __webpack_public_path__ + "static/media/logo-c-64.0d4208ae.png";